/** UAT 暫停 Firebase OTP 時設 VITE_CRM_PHONE_LOGIN_WITHOUT_OTP=true（僅 build 注入） */
export function isCrmPhoneLoginWithoutOtp(): boolean {
  return import.meta.env.VITE_CRM_PHONE_LOGIN_WITHOUT_OTP === 'true';
}
